module.exports = __webpack_public_path__ + "img/poster7.ca4d7561.jpg";